import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import { BaseUrl } from "../helper/BaseUrl";
import ApiRequest from "../helper/ApiRequest";

const mediaListEndpoint = ApiEndpoints.adminMedia.adminMediaList;

const truncateTitle = (title) => {
  if (!title) return "";
  const normalizedTitle = title.replace(/\s+/g, " ").trim();
  return normalizedTitle.length > 82 ? normalizedTitle.slice(0, 82) + "..." : normalizedTitle;
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  return `${month} ${day}, ${year}`;
};

const dataFetch = async (onSuccess) => {
  try {
    const response = await ApiRequest("GET", mediaListEndpoint);
    const result = response.medias;
    onSuccess(result);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export default function MediaPost() {
  const [allData, setAllData] = useState([]);
  const [visibleCards, setVisibleCards] = useState(9);

  useEffect(() => {
    dataFetch(setAllData);
  }, [])

  const handleLoadMore = useCallback(() => {
    setVisibleCards((prev) => {
      const isReset = prev >= allData.length;
      return isReset ? 9 : Math.min(prev + 3, allData.length);
    });
  }, [allData.length]);

  return (
    <>
      <section className="media-section">
        <div className="container">
          <div className="row">
            <div className="media-heading">
              <h1 className="heading">Our <span className="gradiant-color"> Media & News </span></h1>
            </div>
          </div>

          <div className="row">
            {allData?.slice(0, visibleCards).map((data, index) => (

              <div key={index} className="col-lg-4 col-md-6 media-posts">
                <div className="solution-box ">
                  <a rel="nofollow" href={data.link} target="_blank" className="media-link">
                    <div className="solution-box-img">
                      <img
                        className="img-responsive"
                        src={`${BaseUrl}${data.thumbnail_image}`}
                        alt="logo"
                      />
                    </div>

                    <div className="media-content">
                      <div className="media-icon">
                        <img className="img-responsive" src={`${BaseUrl}${data?.logo}`} alt="logo" loading="lazy" />
                        <span>{formatDate(data?.createdAt)}</span>
                      </div>

                      {index === 0 ?
                        <h2> {truncateTitle(data?.title)}</h2> :
                        <h4> {truncateTitle(data?.title)} </h4>
                      }
                    </div>
                  </a>
                </div>
              </div>
            ))}

            <div className="col-lg-12 col-md-12 media-btn">
              <div className="btn-wraps">
                {!(visibleCards >= allData.length && visibleCards === 9) && (
                  <Link id="seeMore" className="default-btn animated-btn" onClick={handleLoadMore}>
                    {visibleCards >= allData.length ? "Load Less" : "Load More"}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
